import { render, staticRenderFns } from "./SodDialog.vue?vue&type=template&id=64320b7f&scoped=true"
import script from "./SodDialog.vue?vue&type=script&lang=js"
export * from "./SodDialog.vue?vue&type=script&lang=js"
import style0 from "./SodDialog.vue?vue&type=style&index=0&id=64320b7f&prod&lang=scss"
import style1 from "./SodDialog.vue?vue&type=style&index=1&id=64320b7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64320b7f",
  null
  
)

export default component.exports